import { ConfigItem } from '@msdk/definitions'

/**
 * Converts a {@link ConfigItem}[] into a key-value `Record`.
 *
 * @param config - A `{key: string, value: string}[]`.
 * @returns A `Record<string, string>` where each key-value pair from the input array becomes a property, or an empty object if the input is null/undefined.
 */
export function resolveConfig(config: ConfigItem[]): Record<string, string> {
  if (!config || !Array.isArray(config)) {
    return {}
  }

  const record: Record<string, string> = Object.fromEntries(config.map((item) => [item.key, item.value]))

  return record
}
